import getECommercePageCountOptionIndex from 'editor/src/store/variants/helpers/getECommercePageCountOptionIndex';

import { RootState } from 'editor/src/store';

import { Spread } from '../types';

import { SpreadRemovalContent, spreadsHoldContent } from './spreadRemovalHoldsContent';

const NO_LOSS: SpreadRemovalContent = { pages: 0, holdsContent: false };

// Inside covers are blank pages a page count leaves out, so the first and last inside spreads can
// print a single page.
function printedPageCount(spread: Spread): number {
  return spread.pages.filter((page) => !page.groups.blank?.length).length;
}

// What a smaller design of `targetPageCount` pages would cost the user. Spreads are numbered from the
// front, so the smaller book's design lacks the trailing ones, and the content carried onto it
// (matched by spread name) leaves theirs behind. The spread the cut runs through counts whole: its
// elements belong to the spread, not to a page, and its dropped half becomes the smaller book's blank.
export function pageCountDropLoss(state: RootState, targetPageCount: number): SpreadRemovalContent {
  const { designData } = state.design;
  if (!designData?.page_count || !targetPageCount || targetPageCount >= designData.page_count) {
    return NO_LOSS;
  }

  const pagesToDrop = designData.page_count - targetPageCount;
  const droppedSpreads: Spread[] = [];
  let droppedPages = 0;
  // The cover is in every page count.
  for (let index = designData.spreads.length - 1; index > 0 && droppedPages < pagesToDrop; index -= 1) {
    droppedSpreads.push(designData.spreads[index]);
    droppedPages += printedPageCount(designData.spreads[index]);
  }

  return {
    pages: pagesToDrop,
    holdsContent: spreadsHoldContent(droppedSpreads, !state.hostSettings.ignorePersonalizationLock),
  };
}

// What switching to `variantId` would cost the user when that variant sells fewer pages.
function pageCountSwitchLoss(state: RootState, variantId: string): SpreadRemovalContent {
  const product = state.variants.eCommerceProduct;
  if (!state.design.designData?.page_count || !product) {
    return NO_LOSS;
  }

  const optionIndex = getECommercePageCountOptionIndex(product);
  const variant = product.variants.find(({ id }) => id === variantId);
  const targetPageCount = optionIndex === -1 ? NaN : parseInt(variant?.optionValues[optionIndex] ?? '', 10);

  return pageCountDropLoss(state, targetPageCount);
}

export default pageCountSwitchLoss;
